/*
 * サブシステム名：マスタ管理
 * 機能名：得意先マスタ登録（※取引先マスタ登録ベース）
 */

import D2MSTD0020 from '@/views/MST/D2MSTD0020.js'

export default ({
  extends: D2MSTD0020,
  name: 'MstTokuisakiEdit',
  methods: {
    // 得意先設定
    setTokuisaki: function () {
      this.tokuisakiFlg = true
    }
  }
})
